import { capitalize } from 'lodash/fp'

const friendlyStringFormatter = (value: string) => {
  return !isNaN(+value) ? `#${value}` : capitalize(value)
}

export default friendlyStringFormatter
